import * as utils from '../utils/utils.js';
import * as userPerms from '../utils/userPerms.js';

export default class Channel {
    constructor($scope, $interval) {
        this.$scope = $scope;
        this.$interval = $interval;
        this.channel = null;
        this.channelEmpty = false;
        this.futureEvents = [];
        this.pastEvents = [];
        this.topEvent = null;
        this.siteSettings = siteSettings;
        this.imageVer = siteSettings.imageVersion;
        this.mediaUrls = [];
    }

    $onInit() {
        if (siteSettings.isIncompatibleBrowser) {
            window.location.href = '/browser';
        } else {
            this.fetchPageContext();
        }
    }

    fetchPageContext() {
        if (!this.siteSettings.enableChannelPages) {
            window.location.href = `/Home/Error?statusCode=404&embed=${siteSettings.isEmbeddedPage}`;
        }

        this.user = utils.getCurrentUser();
        let isUserAADAuthenticated = userPerms.aadAuthenticated(this.user);

        if (!isUserAADAuthenticated && siteSettings.requireOrgSignIn) {
            window.location.href = utils.getSignInUrl(true);
        }

        let apiCallType = isUserAADAuthenticated ? 'int/' : '';
        let reqUrl = `/events/pagecontext/${apiCallType}channel/${pageContext.channelId}`;

        let currentCtrl = this;

        fetch(reqUrl, {
            credentials: 'omit'
        })
            .then(response => {
                utils.setUserLocation(response.headers);

                if (response.status === 401) {
                    utils.log(
                        'channel',
                        'User is not authorized to see channel content, redirecting to AAD sign in',
                        false,
                        1
                    );
                    window.location.href = utils.getSignInUrl(true);
                } else if (response.status !== 200) {
                    // Something went wrong. If this is the first call to the API, or if the channel has been removed,
                    // redirect to error page. Otherwise, ignore to avoid showing error page if API gets temporarily unavailable while page is open
                    utils.log(
                        'channel',
                        `Error fetching channel data, API responded with ${response.status}`,
                        false,
                        3
                    );
                    if (currentCtrl.channel === null || response.status === 404)
                        window.location.href = `/Home/Error?statusCode=${response.status}&embed=${siteSettings.isEmbeddedPage}`;
                    else return;
                } else if (response.status === 200) {
                    return response.json();
                }
            })
            .then(data => {
                if (!data || data.length === 0 || !data.channel) {
                    utils.log(
                        'channel',
                        'Error fetching channel data, response was empty',
                        false,
                        3
                    );
                    return;
                }
                currentCtrl.channel = data.channel;
                currentCtrl.mediaUrls = data.mediaUrls;

                if (data.totalEventCount === 0) {
                    currentCtrl.channelEmpty = true;
                } else {
                    currentCtrl.channelEmpty = false;
                    currentCtrl.topEvent = data.takeOverEvent;
                    currentCtrl.liveEvents = data.liveEvents;
                    currentCtrl.futureEvents = data.futureEvents;
                    currentCtrl.pastEvents = data.pastEvents;
                }

                currentCtrl.$scope.$apply();
            })
            .catch(function(err) {
                utils.log(
                    'channel',
                    'Error while fetching channel data or creating UI components',
                    false,
                    3,
                    err
                );
            });
    }

    getLocalDate(event) {
        if (event === undefined || event === null) return '';
        return utils.parseDateToLocale(event.startTime);
    }

    navigateEvt(evt) {
        window.location.href = evt.directUrl;
    }
}
